'use strict';

var util = require('../util'),
	addressFile = require('./checkout/address'),
	dialog = require('../dialog'),
	ajax = require('../ajax'),
	minicart = require('../minicart'),
	linchpin = require('int_googletagmanager/linchpin/giftguru'),
	formPrepare = require('./checkout/formPrepare');

var orders = {},
	$addressSelect = $('#gift-guru-addresses');

/**
 * Parse orders data from select options attributes
 */
function getOrdersData() {
	var $options = $addressSelect.find('option');
	var ordersCount = 0;
	$options.each(function () {
		var $option = $(this);
		var order = $option.data('order-json');
		if (!order) {
			return;
		}

		$option.attr('value', order.addressLine)
			.text(order.title);
		orders[order.addressLine] = order;
		ordersCount++;
	});

	if (ordersCount === 0) {
		$('.address-select .js-no-orders').show();
	}

	// console.log(orders);
}

function initSelectAddress() {
	$addressSelect.on('change', function (e) {
		var $this = $(this);
		var order = getSelectedOrderData();
		var giftProducts = JSON.stringify(order.products);
		var url = util.appendParamToURL(Urls.giftGuruGetProducts, 'products', giftProducts);
		var $shipmentContainer = $('#gift-container');

		$('.address-select .js-recipient-address')
			.html($this.val())
			.show();
		$('.address-select .js-gift-guru-edit-address').show();

		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.giftGuruEvent(e);
		}

		ajax.load({
			url: url,
			target: $shipmentContainer,
			callback: function () {
				$('.order-history').show();
				initHistoryItems();
			}
		});
	});
}

/**
 * Add product to cart
 */
function initAddToCartEvent () {
	$(document).on('submit', '.js-gift-guru-gift-form', function (e) {
		e.preventDefault();
		var $form = $(this);
		var address = getSelectedOrderData().address;
		var url = util.appendParamsToUrl(Urls.giftGuruStartSession, {
			format: 'ajax',
			title: address.firstName
		});

		// Make request to create a GiftGuru session
		$.ajax({
			url: url,
			data: {address: JSON.stringify(address)},
			method: 'POST',
			success: function (response) {
				if (!response.success) {
					return;
				}

				// Add product to cart
				var url = util.appendParamsToUrl($form.attr('action'), {format: 'ajax'});
				var data = util.getQueryStringParams($form.serialize());
				data.address = JSON.stringify(address);
				$.ajax({
					data: data,
					url: url,
					method: 'POST',
					success: function (response) {
						if (response.success !== false) {
							minicart.show(response);
						}
					}
				});
			}
		});

		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.giftAddedToBagEvent(e, $addressSelect.val());
		}

		return false;
	});
}

function initHistoryItems() {
	var $orderLineItems = $('.order-history .gift-history-item');
	$orderLineItems.on('click', function () {
		var $li = $(this);
		$orderLineItems.removeClass('active');
		$li.addClass('active');

		var productID = $li.find('[data-productid]').data('productid');
		var url = util.appendParamToURL(Urls.giftGuruGetRecomendations, 'pid', productID);
		var $shipmentContainer = $('#gift-guru-recomendations');

		ajax.load({
			url: url,
			target: $shipmentContainer,
			callback: function () {
				// init slider
				$shipmentContainer.find('#carousel-recommendations').slick({
					slidesToShow: 3,
					slidesToScroll: 1,
					infinite: false,
					responsive: [{
						breakpoint: 1024,
						settings: {
							slidesToShow: 2
						}
					}, {
						breakpoint: 480,
						settings: {
							slidesToShow: 1
						}
					}]
				});

				// show recipient name
				var address = getSelectedOrderData().address;
				var $recommendedFor = $('#guru-recommended-for');
				$recommendedFor.text([$recommendedFor.data('msg'),
					address.firstName,
					address.lastName].join(' '));

				// show finished block
				$('.finish-block').show();
			}
		});
	});

	// Select first product
	$orderLineItems.first().trigger('click');
}

function initFinishEvent() {
	$('#gift-guru-finish').on('click', function () {
		var address = getSelectedOrderData().address;
		var url = util.appendParamToURL(Urls.giftGuruFinishPopup, 'address', JSON.stringify(address));
		url = util.appendParamToURL(url, 'title', address.firstName);

		dialog.open({
			url: url,
			options: {
				dialogClass: '',
				title: 'Finished Shopping For ' + address.firstName + ' ?'
			}
		});
	});
}

function quantityEvent() {
	$('#gift-guru-recomendations').on('click', 'span.input-group-btn', function () {
		var operation = $(this).children()[0].innerText,
			qtyField = $(this).siblings('.input-group-qty')[0],
			qty = parseInt(qtyField.value),
			newQty = operation === '-' ? --qty : ++qty;

			if ((operation === '-' && newQty >= parseInt(qtyField.getAttribute('min'))) ||
				(operation === '+' && newQty <= parseInt(qtyField.getAttribute('max')))) {
				qtyField.value = newQty;
				qtyField.setAttribute('value', newQty);
			}
	});
}

function editAddress () {
	$('#gift-guru-edit-address').on('click', function () {
		var orderData = getSelectedOrderData();
		var addressJSON = JSON.stringify(orderData.address);
		var url = util.appendParamToURL(Urls.giftEditAddress, 'address', addressJSON);

		dialog.open({
			url: url,
			options: {
				dialogClass:'shipping-address-dialog addressbook',
				open: function () {
					addressFile.dynamicAddressFieldsHandler($('.shipping-address-dialog .address-form'));
					addressFile.pcaDialogIEFix('.shipping-address-dialog');
					formPrepare.init({
						continueSelector: '[name$="_editAddress_save"]',
						formSelector: $('.shipping-address-dialog .address-form'),
						replaceInvalidInput: true,
						keyup: false,
						autofillValidate: true
					});
					submitEditForm(orderData);
					$('.cancel.button-gray.cancel-button').on('click', function () {
						dialog.close();
					});
				}
			}
		});
	});
}

function submitEditForm (orderData) {
	$('#edit-address-form').on('submit', function () {
		var $form = $(this);

		if (!$form.valid()) {
			return false;
		}

		var options = {
			url: $form.attr('action'),
			data: $form.serialize() + '&format=ajax',
			type: 'POST'
		};

		$.ajax(options).always(function (data) {
			if (data && data.success && data.addressObj) {
				updateAddress(orderData, data.addressObj);
				dialog.close();
			} else {
				window.console.log('some fields needs to be updates');
			}
		});

		return false;
	});
}

/**
 * Create a new select option with edited address
 * @param orderData {Object} Order Data containing old address
 * @param newAddressObject {Object} new address
 */
function updateAddress(orderData, newAddressObject) {
	if (orderData.addressLine === newAddressObject.addressLine) {
		return;
	}

	// Create new Order Data object
	var newOrderData = $.extend({}, newAddressObject);
	newOrderData.products = orderData.products;

	// Create a new option and add it to the address select element
	$('<option>').val(newOrderData.addressLine)
		.text(newOrderData.title)
		.data('order-json', newOrderData)
		.appendTo($addressSelect);

	// Save new order data
	orders[newOrderData.addressLine] = newOrderData;

	// Select new address
	$addressSelect.val(newOrderData.addressLine);
	$addressSelect.trigger('change');
}

/**
 * Capture click event on product links to create a GiftGuru session at first
 */
function initProductTileEvents () {
	$(document).on('click', '#gift-guru-recomendations .product-tile a', function (e) {
		e.preventDefault();
		var $link = $(this);
		var address = getSelectedOrderData().address;
		var url = util.appendParamsToUrl(Urls.giftGuruStartSession, {
			format: 'ajax',
			title: address.firstName
		});

		// Make a request to create a Gift Guru session at first
		$.ajax({
			url: url,
			data: {address: JSON.stringify(address)},
			method: 'POST',
			success: function () {
				// Redirect to PDP
				location.href = $link.attr('href');
			}
		});

		return false;
	});
}

/**
 * Returns order object for selected address
 */
function getSelectedOrderData() {
	var selectedAddrKey = $addressSelect.val();
	return orders[selectedAddrKey];
}

/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
function initializeEvents () {
	getOrdersData();
	initSelectAddress();
	initFinishEvent();
	initProductTileEvents();
	quantityEvent();
	editAddress();
	initAddToCartEvent();
}

var giftguru = {
	init: function () {
		initializeEvents();
	}
};

module.exports = giftguru;
